import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getData({ status, page, pharmacy, limit = 20, short_code, user_email, user_rut, sortOrder }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral`,
			params: { page:page, limit:limit, country:Enviroment.COUNTRY, pharmacy,status, short_code, user_email, user_rut, sortOrder },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getDataById(quotationId) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async removeRecipe({ quotationId, recipe_id, token }) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/recipes/remove`,
			data: { recipe_id },
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
	

	async updateRecipe(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/recipes`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


		async updateUserInfo(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/user-info`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

		async resendQuotationEmail(quotationId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/resend-approved-email`,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async processNewStatus(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/status`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async uploadImage(formData) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/resources/${Enviroment.COUNTRY}`,
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async addComercialProductsToQuotation(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	
	async addMagistralProductsToQuotation(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/magistral-ready`,
			data: body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async exportQuotations(token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/export`,
			data: { country: Enviroment.COUNTRY },
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async requote(body,token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/requote`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}



	async addMagistralToMakeProducts(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async removeCommercialProduct(productId, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial/${productId}/remove`,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async removeMagistralProduct(productId, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/remove`,
			data:{product_id:productId},
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async updateMagistralProducts(body, quotationId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateCommercialProducts(body, quotationId, productId, token) {
		return new AxiosAdapter({
			method: Http.PATCH,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral/${quotationId}/products/commercial/${productId}`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}



	async getRegionsByCountry() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getCommunesByRegion(region) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}/region/${region}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	// Same contract as demo-pharmacy AddressSetLocation: backend geocoding fallback.
	// AxiosInterceptor unwraps statusCode 200 → response.data.data (usually an array).
	async geocodeAddress(query) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/location/geocoding/${Enviroment.LANGUAGE}`,
			params: { q: query },
		})
			.request()
			.then((response) => {
				const first = Array.isArray(response) ? response[0] : null;
				if (!first?.lat || !first?.lng) return null;
				return {
					lat: Number(first.lat),
					lng: Number(first.lng),
					address: first.address_complete || '',
				};
			})
			.catch((e) => {
				throw e;
			});
	}

	async manualPurchaseCalculation(body, token) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_BACKEND}/purchases/manual-purchase`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}


	async manualPurchase(body, token) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.FUNCTION_BACKEND}/purchases/manual-purchase/${body.order_main_calculation}`,
			data:body,
			headers: {
				Authorization: `Bearer ${token}`,
			},		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async uploadToSignedUrl(signedUrl, file) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: signedUrl,
			data: file,
			headers: {
				'Content-Type': file.type || 'application/octet-stream',
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
